export * from '@primeuix/themes/material/progressspinner';
export { default } from '@primeuix/themes/material/progressspinner';
